import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import '@facet/tokens/tokens.css';
import './styles/global.css';
import { AppProvider } from './state/store';
import { App } from './App';

// BrowserRouter → clean, crawlable URLs (/guides, /science). CloudFront returns
// index.html for any path (SPA fallback configured in infra/lib/web-stack.ts),
// so deep links resolve; Vite dev + preview do the same fallback locally.
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AppProvider>
        <App />
      </AppProvider>
    </BrowserRouter>
  </StrictMode>,
);
